var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 5,
    fill: "#F3F6F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4139_30980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.75 11H22.425C22.2509 10.1536 21.7904 9.39301 21.1209 8.84654C20.4515 8.30007 19.6142 8.00109 18.75 8L17.25 8C16.3858 8.00109 15.5485 8.30007 14.8791 8.84654C14.2096 9.39301 13.7491 10.1536 13.575 11H11.25C11.0511 11 10.8603 11.079 10.7197 11.2197C10.579 11.3603 10.5 11.5511 10.5 11.75C10.5 11.9489 10.579 12.1397 10.7197 12.2803C10.8603 12.421 11.0511 12.5 11.25 12.5H12V22.25C12.0012 23.2442 12.3967 24.1973 13.0997 24.9003C13.8027 25.6033 14.7558 25.9988 15.75 26H20.25C21.2442 25.9988 22.1973 25.6033 22.9003 24.9003C23.6033 24.1973 23.9988 23.2442 24 22.25V12.5H24.75C24.9489 12.5 25.1397 12.421 25.2803 12.2803C25.421 12.1397 25.5 11.9489 25.5 11.75C25.5 11.5511 25.421 11.3603 25.2803 11.2197C25.1397 11.079 24.9489 11 24.75 11ZM17.25 9.5H18.75C19.2152 9.50057 19.6688 9.64503 20.0487 9.91358C20.4286 10.1821 20.7161 10.5616 20.8718 11H15.1283C15.2839 10.5616 15.5714 10.1821 15.9513 9.91358C16.3312 9.64503 16.7848 9.50057 17.25 9.5ZM22.5 22.25C22.5 22.8467 22.2629 23.419 21.841 23.841C21.419 24.2629 20.8467 24.5 20.25 24.5H15.75C15.1533 24.5 14.581 24.2629 14.159 23.841C13.7371 23.419 13.5 22.8467 13.5 22.25V12.5H22.5V22.25Z",
    fill: "#E63050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 21.5C16.6989 21.5 16.8897 21.421 17.0303 21.2803C17.171 21.1397 17.25 20.9489 17.25 20.75V16.25C17.25 16.0511 17.171 15.8603 17.0303 15.7197C16.8897 15.579 16.6989 15.5 16.5 15.5C16.3011 15.5 16.1103 15.579 15.9697 15.7197C15.829 15.8603 15.75 16.0511 15.75 16.25V20.75C15.75 20.9489 15.829 21.1397 15.9697 21.2803C16.1103 21.421 16.3011 21.5 16.5 21.5Z",
    fill: "#E63050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 21.5C19.6989 21.5 19.8897 21.421 20.0303 21.2803C20.171 21.1397 20.25 20.9489 20.25 20.75V16.25C20.25 16.0511 20.171 15.8603 20.0303 15.7197C19.8897 15.579 19.6989 15.5 19.5 15.5C19.3011 15.5 19.1103 15.579 18.9697 15.7197C18.829 15.8603 18.75 16.0511 18.75 16.25V20.75C18.75 20.9489 18.829 21.1397 18.9697 21.2803C19.1103 21.421 19.3011 21.5 19.5 21.5Z",
    fill: "#E63050"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4139_30980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.710726e72139288aa00af5af4eca1cf3.svg";
export { ForwardRef as ReactComponent };